module.exports = __webpack_public_path__ + "static/media/user-profile-person-svgrepo-com.0008a739.svg";